import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import { createMeasure } from '../thunk';

import type { MeasureInputType } from '@/domain/measure/component/MeasureFormInput';
import type { ChildJson } from '@/types/domain/child/entities/childEntity';
import type { UserType } from '@/types/domain/user/redux';

import DialogTitle from '@/components/DialogTitle';
import DialogTransition from '@/components/DialogTransition';
import MeasureFormInput from '@/domain/measure/component/MeasureFormInput';

/**
 * 入力
 */
export type AddMeasureInput = {
  /** 開く */
  isOpen: boolean,
  /** 閉じる */
  close: () => void,
  /** ユーザー */
  user: UserType,
  /** 子ども */
  child: ChildJson,
};

const AddMeasure: React.FC<AddMeasureInput> = ({
  isOpen,
  close,
  user,
  child,
}) => {
  const dispatch = useDispatch();
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<MeasureInputType>({
    defaultValues: {
      height: '',
      weight: '',
      headCircumference: '',
      chestCircumference: '',
    },
  });
  const onSubmit = (input: MeasureInputType) => {
    const username = user.name;
    const height = parseFloat(input.height);
    const weight = parseFloat(input.weight);
    const headCircumference = parseFloat(input.headCircumference);
    const chestCircumference = parseFloat(input.chestCircumference);
    dispatch(createMeasure({
      data: {
        measureDate: (new Date()).toJSON(),
        height: Number.isNaN(height) ? undefined : height,
        weight: Number.isNaN(weight) ? undefined : weight,
        headCircumference: Number.isNaN(headCircumference) ? undefined : headCircumference,
        chestCircumference: Number.isNaN(chestCircumference) ? undefined : chestCircumference,
        measurerId: username,
        measurerType: 'app',
        parentId: username,
        childId: child.childId,
      },
      pub: {
        sendId: username,
        replyId: username,
        data: {},
      },
    }));
    close();
  };
  return (
    <Dialog
      open={isOpen}
      onClose={() => close()}
      TransitionComponent={DialogTransition}
      fullScreen
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogTitle title="成長記録の登録" />
        <DialogContent>
          <MeasureFormInput
            control={control}
            errors={errors}
          />
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            type="submit"
            color="primary"
          >
            登録する
          </Button>
          <Button
            variant="contained"
            onClick={() => close()}
            color="primary"
          >
            閉じる
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default AddMeasure;
